/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Toc_EndInputs */

const en_blog_toc_end = /** @type {(inputs: Blog_Toc_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we work together`)
};

const lv_blog_toc_end = /** @type {(inputs: Blog_Toc_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā mēs strādājam kopā`)
};

/**
* | output |
* | --- |
* | "How we work together" |
*
* @param {Blog_Toc_EndInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_toc_end = /** @type {((inputs?: Blog_Toc_EndInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Toc_EndInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_toc_end(inputs)
	return en_blog_toc_end(inputs)
});